<template>
    <section class="content">
        <section class="content-header">
            <div class="containter-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1>Promociones</h1>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                            <li class="breadcrumb-item active">Promociones</li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4">
                    <div id="btn-agregar-promocion" class="info-box mb-3">
                        <router-link to="/nuevapromocion" class="btn btn-block info-box-icon bg-info elevation-1"><i
                                class="fas fa-plus"></i></router-link>
                        <div class="info-box-content">
                            <span class="info-box-text">Promocion</span>
                            <span class="info-box-number">Agregar</span>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="card card-primary card-outline">
                        <div class="card-header">
                            <h3>Tabla de historico de promociones</h3>
                        </div>
                        <div class="card-body">
                            <table id="promocionesTable" class="table table-bordered table-striped"></table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, nextTick } from "vue";
import { useRouter } from "vue-router";
import api from "@/services/api";
import { tutorial } from "@/plugins/tutorial";
import { loading } from '@/plugins/loading';
import { alert } from '@/plugins/alert';

export default {
    setup() {
        const router = useRouter();
        const dtInstance = ref(null);
        const promociones = ref([]);

        async function fetchPromociones() {
            try {
                loading.show('Cargando promociones...');
                const { data } = await api.get("/promociones");
                promociones.value = data;
                loading.hide();
            } catch (error) {
                loading.hide();
                alert.show({ title: 'Error', text: 'No se pudieron cargar las promociones', icon: 'error' });
                console.error("Error al cargar promociones:", error);
            }
        }

        function verDetalle(id) {
            router.push(`/promocion/${id}`);
        }

        function initDataTable() {
            const table = window.$("#promocionesTable").DataTable({
                data: promociones.value,
                responsive: true,
                destroy: true,
                columns: [
                    { title: "Código", data: "codigo" },
                    { title: "Descripción", data: "descripcion" },
                    { title: "Tipo", data: "modo" },
                    { title: "Inicio", data: "fecha_inicio" },
                    { title: "Fin", data: "fecha_fin", defaultContent: "Sin fecha" },
                    { title: "Estado", data: "estado" },
                    { title: "Clientes", data: "all_clients", render: d => d ? "Todos" : "Algunos" },
                    { title: "Productos", data: "all_products", render: d => d ? "Todos" : "Algunos" },
                    {
                        title: "Acciones",
                        data: null,
                        orderable: false,
                        render: function (data, type, row) {
                            return `<button class="btn btn-sm btn-primary ver-detalle" data-id="${row.id}">Detalles</button>`;
                        }
                    }
                ],
                pageLength: 10,
                columnDefs: [
                    { responsivePriority: -1, targets: 0 },
                    { responsivePriority: 1, targets: 1 },
                    { responsivePriority: 1, targets: 8 }
                ],
                lengthChange: false,
                pagingType: 'numbers',
                language: {
                    url: 'https://cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json'
                },
                dom: '<"row mb-3"<"col-12 col-md-6"f>>t<"row mt-3"<"col-12 text-center"i>><"row"<"col-12 d-flex justify-content-center"p>>',
            });

            window.$("#promocionesTable tbody")
                .off("click")
                .on("click", ".ver-detalle", function () {
                    const id = window.$(this).data("id");
                    verDetalle(id);
                });

            dtInstance.value = table;
        }

        function iniciarTutorial() {
            const steps = [
                {
                    element: '#btn-agregar-promocion',
                    title: 'Nueva Promoción',
                    text: 'Haz clic aquí para crear una nueva promoción.',
                    position: 'bottom'
                },
                {
                    element: '.card-body',
                    title: 'Histórico',
                    text: 'Aquí puedes ver y filtrar todas las promociones registradas.',
                    position: 'top'
                },
                {
                    element: '.ver-detalle',
                    title: 'Detalles',
                    text: 'Usa este botón para ver la configuración específica de la promoción.',
                    position: 'left'
                }
            ];
            tutorial.start(steps);
        }

        onMounted(async () => {
            await fetchPromociones();
            await nextTick();
            initDataTable();
            tutorial.set(iniciarTutorial);
        });

        onBeforeUnmount(() => {
            if (dtInstance.value) {
                dtInstance.value.destroy();
            }
            tutorial.set(null);
        });

        return {
            promociones,
            verDetalle
        };
    }
};
</script>

<style>
.hide-next-btn .introjs-nextbutton, .hide-next-btn .introjs-nextBtn {
  display: none !important;
}
</style>
